export default __webpack_public_path__ + "static/imgg1-8035004e88402b54f0b127faa030e82f.jpg";